import React from "react";
import { Button, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClearIcon from "@material-ui/icons/Clear";
import { useConfigs } from "../config-provider";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      border: "1px solid #eee",
      background: "#eee",
      borderRadius: theme.spacing(2),
      padding: "4px 10px 4px 13px",
      height: 32,
      textTransform: "none",
      "&:hover": {
        background: "#ddd"
      }
    },
    hover: {
      "& $arrow": {
        transform: "rotate(180deg)",
        transition: "all .3s"
      }
    },
    selected: {
      border: "1px solid ".concat(theme.palette.primary.main),
      background: theme.palette.primary.light,
      color: theme.palette.primary.main,
      "&:hover": {
        background: theme.palette.primary.light
      },
      "& svg": {
        color: theme.palette.primary.main
      },
      "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.5)
      }
    },
    arrow: {
      cursor: "pointer",
      padding: 1
    },
    clear: {
      cursor: "pointer"
    },
    label: {
      whiteSpace: "nowrap",
      marginRight: 4
    }
  };
});

var Dropdown = function Dropdown(_a) {
  var label = _a.label,
      preLabel = _a.preLabel,
      value = _a.value,
      startIcon = _a.startIcon,
      open = _a.open,
      onClick = _a.onClick,
      onClear = _a.onClear;
  var locale = useConfigs().locale;
  var classes = useStyles();
  return React.createElement(Button, {
    onClick: onClick,
    className: clsx(classes.root, value && classes.selected, open && classes.hover),
    startIcon: startIcon
  }, React.createElement(Typography, {
    variant: "body2",
    className: classes.label
  }, preLabel ? "".concat(preLabel).concat(locale.common.colon) : "", value ? value : label ? label : locale.common.all), value && React.createElement(ClearIcon, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear();
    },
    fontSize: "small",
    color: "action",
    className: classes.clear
  }), React.createElement(ArrowDropDownIcon, {
    color: "action",
    className: classes.arrow
  }));
};

export default Dropdown;